"use client";
import type { LucideIcon } from "lucide-react";
import { Clock, Check, Plus, AlertCircle, Minus } from "lucide-react";
import { cn } from "@/lib/utils";
import type { AppointmentStatus } from "@/lib/appointment/status";

const ICONS: Record<AppointmentStatus, LucideIcon> = {
  waiting: Clock,          // ⏰
  confirmed: Check,        // ✔
  arrived_paid: Plus,      // ➕
  arrived_unpaid: AlertCircle, // ❗
  no_show: Minus,          // ➖
};

export function StatusGlyph({
  status,
  className,
  title,
}: {
  status: AppointmentStatus;
  className?: string;
  title?: string;
}) {
  const Icon = ICONS[status];
  return <Icon className={cn("w-3.5 h-3.5", className)} aria-label={title ?? status} />;
}
